import SectionHeading from "@/components/base/SectionHeading";

const principles = [
  {
    no: "01",
    title: "只整理公开信息",
    desc: "所有内容都来自公开渠道，不采用私下获取的材料，也不做未经证实的推断。",
  },
  {
    no: "02",
    title: "争议并列呈现",
    desc: "当同一件事出现多种说法，我们会把各方口径放在一起，而不是替读者下结论。",
  },
  {
    no: "03",
    title: "标明进展状态",
    desc: "仍在进行中的话题会明确标注「持续更新」，避免读者把阶段性信息当成最终结果。",
  },
  {
    no: "04",
    title: "不打扰当事人",
    desc: "讨论聚焦公开动态，不鼓励跟拍、不公开私人信息，也不引导对个人的过激评价。",
  },
  {
    no: "05",
    title: "错了就改",
    desc: "如果发现信息有误或已过时，我们会在原处补充更正说明，而不是悄悄删除。",
  },
];

export default function PrinciplesSection() {
  return (
    <section
      id="values"
      className="w-full px-4 md:px-8 py-12 md:py-16 bg-secondary-50 border-y border-secondary-100 scroll-mt-24"
    >
      <SectionHeading
        eyebrow="内容原则"
        title="我们给自己定的五条规矩"
        desc="吃瓜可以热闹，但整理信息这件事必须认真。"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {principles.map((item, index) => (
          <div
            key={item.no}
            className={`rounded-lg bg-background-50 border border-secondary-200 p-5 md:p-6 ${
              index === 0 ? "lg:col-span-2 lg:row-span-1" : ""
            }`}
          >
            <span className="font-display text-2xl text-secondary-600">
              {item.no}
            </span>
            <h3 className="mt-2 text-base md:text-lg font-bold text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}